<ion-header>
  <ind-header-left
    [viewData]="indHeaderLeftModel"
    [hideFilterButton]="hideFilterButton"
    [filterButtonBadgeCount]="filterButtonBadgeCount"
    [(searchText)]="medicalInquiryService.searchText"
    (onControlClick)="onControlClick($event)"
    (onSearchInput)="searchInput($event)"
    (onFilterClick)="onFilterClick()">
  </ind-header-left>
</ion-header>
<ion-content>
  <div *ngIf="showTeamLoading" class="mi-team-list-loading">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
  <ion-item-group *ngIf="!showTeamLoading" id="listScroll">
    <ion-item-divider color="light" class="list-title normal-divider">
      <ion-label class="title-text">{{ headerCountLabel }}</ion-label>
    </ion-item-divider>

    <ng-container *ngIf="hasFilteredResults else noSearchResult">
      <ion-list>
        <div *ngFor="let card of displayedCards; let i = index; trackBy: trackByCardId" (click)="onCardClick(displayedMedicalInquiries[i])" class="medical-inquiry-list-item">
          <main-card [viewData]="card"></main-card>
        </div>
      </ion-list>
      <ion-infinite-scroll *ngIf="hasFilteredResults && hasMoreItems" [disabled]="infiniteScrollDisabled" (ionInfinite)="doInfinite($event)" threshold="20%">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ng-container>
    <ng-template #noSearchResult>
      <ind-no-search-result *ngIf="searchText && !hasFilteredResults else noData;" [text]="('NO_RESULTS_FOR_THIS_SEARCH' | translate)"></ind-no-search-result>
    </ng-template>
    <ng-template #noData>
      <ion-list>
        <ion-item class="reconciliation-list-empty">
          <div class="no-data-message">{{ noDataMessage | translate }}</div>
        </ion-item>
      </ion-list>
    </ng-template>
  </ion-item-group>
</ion-content>
